import { useEffect, useState } from "react";
import { isAfter } from "date-fns";

import { ReactComponent as CalendarIcon } from "assets/icons/Bookings/calendar.svg";
import { useMediaQuery } from "hooks/useMediaQuery";

import { DatePicker } from "components/DatePicker";

import { MobileDatePickerRangeDrawer } from "./MobileDatePickerRangeDrawer";
import styles from "./DateRangeInput.module.scss";

export const REGULAR_DATE_FORMAT = "dd MMM, YYYY";

export const DateRangeInput = ({ value, onChange, ranges = {} }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [isMobilePickerVisible, setIsMobilePickerVisible] = useState(false);

  const hideMobilePicker = () => {
    setIsMobilePickerVisible(false);
  };

  const showMobilePicker = () => {
    setIsMobilePickerVisible(true);
  };

  useEffect(() => {
    /**
     * Hide the mobile range input picker when the user expanded the browser
     * so when the user shrink back the browser, the panel will be hidden.
     */
    if (!isMobile) {
      /**
       * When `isMobile` changes to `false`
       * then hide mobile picker drawer.
       */
      hideMobilePicker();
    }
  }, [isMobile]);

  const applyMobilePicker = (range) => {
    if (typeof onChange === "function") {
      onChange(range);
    }
    setIsMobilePickerVisible(false);
  };

  if (!isMobile) {
    return (
      <DatePicker
        isRange
        allowClear={false}
        disabledDate={isFuture}
        format={REGULAR_DATE_FORMAT}
        separator={<RangeSeparator />}
        suffixIcon={<CalendarIcon />}
        value={value}
        onChange={onChange}
        ranges={ranges}
      />
    );
  }

  return (
    <>
      <DatePicker
        isRange
        allowClear={false}
        open={false}
        disabledDate={isFuture}
        format={REGULAR_DATE_FORMAT}
        separator={<RangeSeparator />}
        suffixIcon={<CalendarIcon />} 
        value={value}
        onClick={showMobilePicker}
        ranges={ranges}
      />

      <MobileDatePickerRangeDrawer
        visible={isMobilePickerVisible}
        value={value}
        onClose={hideMobilePicker}
        onApply={applyMobilePicker}
      />
    </>
  );
};

export function isFuture(date) {
  return isAfter(new Date(date), new Date());
}

function RangeSeparator() {
  return <div className={styles.dateRangeSeparator}>-</div>;
}
